const tooltips = [
  "Stay Curious: We're constantly updating our content for you, all annouced on Discord!",
  'We Value Your Voice: Share your feedback with us on Discord!',
  'Creative Twist: Use multiple brackets for dramatic emphasis ((like this)).',
  'Found a Favorite? Lock your seed and refine your prompt to perfection.',
  'Enhance Your Images: Upscale post-generation for stunning clarity.',
  "Character Consistency: Pro users can 'Use Character' for recurring themes.",
  'Inspiration Awaits: Clone any image from Explore to adopt its settings.',
  'Express Yourself: Customize your username, profile picture, and bio.',
  'Create Your Gallery: Hover and select images to curate personal albums.',
  'Privacy Your Way: Publish images publicly or in a private folder.',
  'Seek and You Shall Find: Use our search feature for creative inspiration.',
  'Try Chat: Experience your spicy AI girlfriend chatbot!',
  'PromptApp: Check out our mobile app for creativity on-the-go.',
  'Bring Ideas to Life: Try Video Mode for captivating AI-generated clips.',
  'Friends Share Gems: Get free Gems by introducing Promptchan to friends.',
  'Community Connection: Share ideas on our vibrant Discord community.',
  'Keep the Memories: Heart an image to save it in your profile for later.',
  'Dual Power: Combine AI Character and Custom Pose for extraordinary results.',
  'Style It Up: Experiment with Styles and Filters for a unique aesthetic.',
  'Your Favorites, Bookmarked: Easily revisit your top prompts.',
  'Fresh Start: Reset your session to spark new ideas.',
  'Support Us: Please share Promptchan online, it is the best way to support us!',
  'Animate: Turn your image creations into full motion videos, just press Animate!',
]

export default tooltips
